<script setup lang="ts">
import { apiSyncVisit } from '@api/syncVisit';
import IconVisits from '@assets/icons/visits.svg';
import { BaseButton } from '@components/base';
import { useFetch } from '@helpers/use-fetch';
import { ref } from 'vue';
import { useToast } from 'vue-toast-notification';

const props = defineProps<{
  treatmentId?: number | null;
  patientId: number;
  submissionId?: number | null;
}>();

const emit = defineEmits<{
  next: [],
}>();

const toast = useToast();

const loading = ref(false);
const isAvailable = ref(false);

const getQualifyIsAvailable = useFetch(apiSyncVisit.isQualifyAvailable);
getQualifyIsAvailable.execute({}).then((response) => {
  isAvailable.value = response?.data?.available ?? false;
}).catch(() => {
  isAvailable.value = false;
});

const makeACall = async () => {
  if (props.patientId || props.treatmentId) {
    loading.value = true;
    try {
      const getInvitationData = useFetch(apiSyncVisit.getInvitationData);

      const response = await getInvitationData.execute({
        patientId: props.patientId,
        treatmentId: props.treatmentId ?? null,
        submissionId: props.submissionId ?? null,
        sendEmail: true,
      });

      const meetingUrl = response?.data?.meeting_url;

      if (meetingUrl) {
        window.location.href = meetingUrl;
      }
    } catch (error) {
      toast.error('Error while connecting to Qualify service');
    } finally {
      loading.value = false;
    }
  }
};
</script>

<template>
  <div class="flex flex-col items-center justify-center w-full">
    <BaseButton
      data-testpl="qualify-make-call-btn"
      class="grow bg-deep-blue text-white"
      text="Make a Call"
      :loading="loading"
      :disabled="!isAvailable"
      @click="makeACall"
    >
      <template #icon-left>
        <IconVisits />
      </template>
    </BaseButton>

    <p
      v-if="!isAvailable"
      class="text-center mt-5"
    >
      Qualify service is unavailable now.<br>
      You can finish your quiz later from your personal account page
    </p>
  </div>
</template>
